export default {

  props: {

    value: {
      type: [String, Number, Object, Array, Boolean, Symbol],
      required: false,
    },
  },

  methods: {

    /*
     * emits 'input' event w/ given value
     * @param value
     */
    emitInput (...args) {
      // shortcut: interacts w/ input mixin "disabled" & "readonly" props.
      if (this.disabled || this.readonly) return

      this.$emit('input', ...args)
      this.emitChange(...args)
    },

    /*
     * emits 'change' event w/ given value
     * @param value
     */
    emitChange (...args) {
      // shortcut: interacts w/ input mixin "disabled" & "readonly" props.
      if (this.disabled || this.readonly) return

      this.$emit('change', ...args)
    },
  },
}
